export default __webpack_public_path__ + "static/media/banner-ordinary-coverage.0d16ad8e.png";